export default "__VITE_ASSET__DUulrWtV__"